import { render, staticRenderFns } from "./CreateCampaignName.vue?vue&type=template&id=39f997cd&scoped=true"
import script from "./CreateCampaignName.vue?vue&type=script&lang=js"
export * from "./CreateCampaignName.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignName.vue?vue&type=style&index=0&id=39f997cd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39f997cd",
  null
  
)

export default component.exports